import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { hasRoles } from '../../auth/hasRoles';

export function AdminRoute() {
  if (hasRoles() === 'administrateur') {
    return <Outlet />;
  }
  return <Navigate to="/specialists" replace />;
}
